import {useLocation} from 'react-router-dom';
import {useUserData} from '../../auth';
import {habiOrganizationAllowed,pilotEnvironmentAllowed} from './pilotGate';
/** Presentation experiment is bounded to the existing DEV QA tenant. */
export function useFluPilot(){
 const {organizationId}=useUserData();const location=useLocation();
 const mode=new URLSearchParams(location.search).get('consultant');
 return !['off','habi'].includes(mode||'')&&habiOrganizationAllowed(organizationId)&&pilotEnvironmentAllowed(import.meta.env.DEV||import.meta.env.VITE_HABI_PILOT_ENABLED==='true',import.meta.env.VITE_SUPABASE_URL,import.meta.env.VITE_CORE_URL,window.location.hostname);
}
